import { Outlet, To } from 'react-router-dom'

import { DocumentsDataTableQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'

import { Folder } from 'modules/documents/hooks/useGetFolders'

type Props = {
  parentRoute?: To
  folder?: Folder | null
  initialFolder?: Folder | null
  employeeId?: string
  space?: string
  isLoading?: boolean
}

const ContextFromPage = ({
  parentRoute,
  folder,
  initialFolder,
  employeeId,
  space,
  isLoading = false,
}: Props) => {
  const dataTable = useDataTable<DocumentsDataTableQuery>()
  const documentsEntity = dataTable.data

  const contextValue = {
    documentsEntity,
    folder: folder,
    initialFolder: initialFolder,
    employeeId,
    parentRoute,
    space,
    isLoading,
  }

  return <Outlet context={contextValue} />
}

export default ContextFromPage
